import {MAX_DECIMAL_SYMBOLS as MAX_DECIMALS} from 'shared/format';
import {commaSymbol, sizeOf, isEmpty} from 'ui/keyboard';

const MAX_SYMBOLS = 15;

function decimalsCount(state: KeyboardState): number {
  return sizeOf(state) - (state.indexOf(commaSymbol.value) + 1);
}

function isComma(value: string): boolean {
  return value === commaSymbol.value;
}

function isZero(value: string): boolean {
  return value === '0';
}

export function addSymbol(state: KeyboardState, value: string): KeyboardState {
  if (isEmpty(state) && isZero(value)) return state;
  if (isEmpty(state) && isComma(value)) return ['0', value];
  if (sizeOf(state) >= MAX_SYMBOLS) return state;

  if (state.includes(commaSymbol.value)) {
    if (isComma(value)) return state;
    if (decimalsCount(state) >= MAX_DECIMALS) return state;
  }

  return [...state, value];
}
